/* eslint-disable import/prefer-default-export */

import sessionActionTypes from 'app_modules/session/constants'

export const resetState = options => ({
  payload: options,
  type: sessionActionTypes.RESET_STATE,
})
